import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import UpdateTitleMiddleware from './middlewares/UpdateTitle'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

let updateTitleMiddleware = new UpdateTitleMiddleware

router.beforeEach((to, from, next) => {
  scroll(0,0)

  if (updateTitleMiddleware.handle(to, from, next))
    next()
})

export default router
